<div class="container-fluid main-page main-page-padding">
    <div class="blocker"></div>
    <div class="top-nav-bar-container">
        <div class="top-nav-bar">
            <span class="title"> KPI Dashboard: {{buyerName}}</span>
            <div class="top-nav-btns">
                <button [ngClass]="defaultPeriodType === 'YTD' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('YTD', false)">YTD</button>
                <button [ngClass]="defaultPeriodType === 'QTD' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('QTD', false)">QTD</button>
                <button [ngClass]="defaultPeriodType === 'MTD' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('MTD', false)">MTD </button>
                <button [ngClass]="defaultPeriodType === 'WTD' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('WTD', false)">WTD</button>
                <button [ngClass]="defaultPeriodType === 'PW' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('WTD', true)">PW</button>

            </div>
        </div>
    </div>
    <div class="page-content-widgets">
        <div #gridContainer class="grid-stack" >
            <div class="grid-stack-item" data-gs-id="grade-match">
                <div class="grid-stack-item-content">
                    <app-grade-match></app-grade-match>
                </div>
            </div>

            <div class="grid-stack-item" data-gs-id="cars-flexed-on">
                <div class="grid-stack-item-content">
                    <app-cars-flexed-on></app-cars-flexed-on>
                </div>
            </div>
        
           <div class="grid-stack-item" data-gs-id="nps">
                <div class="grid-stack-item-content">
                    <app-nps></app-nps>
                </div>
            </div>
        
            <div class="grid-stack-item" data-gs-id="average-purchase-time">
                <div class="grid-stack-item-content" >
                    <app-average-purchase-time></app-average-purchase-time>
                </div>
            </div>
        
            <div class="grid-stack-item"  data-gs-id="conversion">
                <div class="grid-stack-item-content">
                    <app-conversion></app-conversion>
                </div>
            </div>
        
            <div class="grid-stack-item" data-gs-id="region-rank">
                <div class="grid-stack-item-content">
                    <app-region-rank [username]="username"></app-region-rank>
                </div>
            </div>

            <div class="grid-stack-item" data-gs-id="amount-spent">
                <div class="grid-stack-item-content" >
                    <app-amount-spent></app-amount-spent>
                </div>
            </div>

            <div class="grid-stack-item" data-gs-id="payments">
                <div class="grid-stack-item-content" >
                    <app-payments></app-payments>
                </div>
            </div>
            
            <div class="grid-stack-item" data-gs-id="avg-purchase-price">
                <div class="grid-stack-item-content" >
                    <app-average-purchase-price></app-average-purchase-price>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="loading" class="text-center">
        <app-loading-wbac-animation></app-loading-wbac-animation>
    </div>
</div>
